<template>
  <div class="notice_list">
		<div class="r-s-list-tbody">
			<van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad"
      >
        <template v-for="(item,index) in noticeList">
          <van-cell :key="item.id" @click="handleToInfo(item)">
            <div class="notice_content">
              <van-tag v-if="index == 0" type="danger" plain>新</van-tag>
              <p>
                <span class="custom-title">{{item.title}}</span>
                <span class="date">{{item.time}}</span>
              </p>
            </div>
          </van-cell>
        </template>
      </van-list>
		</div>
  </div>
</template>
<script>
export default {
  data(){
    return {
      noticeList: [],
      loading: false,
      finished: false,
      pageNum: 1,
      pageSize: 10,
      total: 0,
    }
  },
  mounted(){

  },
  methods: {
    onLoad() {
      this.getList();
    },
    async getList() {
      this.loading = true;
      this.finished = false;
      if (this.total > 0 && this.total === this.noticeList.length) {
        this.finished = true;
      }
      const { error, success } = await this.$request('NOTICE_LIST',{
        businessId: Number(localStorage.getItem('ma6_parentBusinessEntityId')),
        pageNum: this.pageNum,
        pageSize: this.pageSize,
      })
      this.loading = false;
      if(success) {
        let data = success.data || {};
        this.noticeList = [...this.noticeList, ...data.list];
        
        (this.noticeList || []).map(item =>{
          item.title = `${item.noticeTitle} 公告`;
          item.time = this.$format(item.createTime, "YYYY/MM/DD");
          item.createTime = this.$format(item.createTime, "YYYY-MM-DD HH:mm:ss");
          return item;
        });
        this.total = data.total;
        this.pageNum ++;
        if(this.pageNum > data.pages){
          this.finished = true;
        }
      }else {
        this.finished = true;
      }
    },
    handleToInfo(item){
      this.$router.push({
        path: "/notice/info",
        query: { 
          title: item.noticeTitle,
          noticeContent: item.noticeContent,
          createTime: item.createTime
        }
      });
    }
  },

}
</script>
<style lang="scss" scoped>
.van-cell__title{
  text-indent: px2rem(4);
  display: flex;
}
.notice_content{
  display: flex;
  p{
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex: 1;
    padding-left: px2rem(12);
    span{
      font-size: px2rem(32);
    }
    .date{
      color: #7d7e80;
      font-size: px2rem(28);
    }
  }
}
</style>